import { HTTPClientInterface } from "./HTTPClientInterface";
import { Logger } from "@utils/Logger";
import { Analytics } from "./Analytics/Analytics";

const environment = process.env.REACT_APP_FRONT_ENV || 'PROD';

export class CoreDependencies {
    private _httpClient: HTTPClientInterface;
    private _unauthenticatedHTTPClient: HTTPClientInterface;
    readonly analytics: Analytics

    constructor(
        httpClient: HTTPClientInterface,
        unauthenticatedHTTPClient: HTTPClientInterface,
    ) {
        this._httpClient = httpClient;
        this.analytics = new Analytics(httpClient)   
        this._unauthenticatedHTTPClient = unauthenticatedHTTPClient
        let organizationID = environment == "PROD" ? "QONTACT" : "WA-DEMO"
        this.analytics.setSelectedOrganizationID(organizationID)
        // this._httpClient.verbose = true
        // this._unauthenticatedHTTPClient.verbose = true
    }

    public get httpClient(): HTTPClientInterface {
        return this._httpClient
    }

    public get unauthenticatedHTTPClient(): HTTPClientInterface {
        return this._unauthenticatedHTTPClient
    }

    public setAPIToken(token: string) {
        Logger.logObject("http client headers ID", (this._httpClient as any)?.instanceID)
        this._httpClient.setClientHeaders({
            "Content-Type": "application/json",
            "x-access-token": token
        })
    }
}